import { render, staticRenderFns } from "./SearchRecruits.vue?vue&type=template&id=31c3107c&scoped=true"
import script from "./SearchRecruits.vue?vue&type=script&lang=js"
export * from "./SearchRecruits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3107c",
  null
  
)

export default component.exports